const _ = require('lodash');

module.exports = function () {
    return {
        restrict: 'A',
        scope: false,
        controller: [
            '$element', '$attrs', function ($element, $attrs) {
                const features = {
                    menubar: $attrs.windowMenubar || 'no',
                    toolbar: $attrs.windowToolbar || 'no',
                    resizable: $attrs.windowResizable || 'yes',
                    scrollbars: $attrs.windowScrollbars || 'yes',
                    height: $attrs.windowHeight || 420,
                    width: $attrs.windowWidth || 550,
                };
                const featureString = _.map(features, (value, feature) => `${feature}=${value}`).join(',');

                $element.on('click', (e) => {
                    e.preventDefault();

                    window.open($attrs.href, $attrs.windowTitle, featureString);
                });
            },
        ],
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/openwindow/open-window.directive.js